/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-02-27",
    versionChannel: "nightly",
    buildDate: "2023-02-27T00:20:18.745Z",
    commitHash: "23192b41498c431f4b745a8eabefa707acc5d32a",
};
